export default __webpack_public_path__ + "images/FP.6027624.png";